import { fork, call, all, put, takeEvery, takeLatest, select } from 'redux-saga/effects'; // eslint-disable-line
import { REPORTS } from 'STORE/constants';
import { removeEmptyKeys, getStoreState } from 'HELPERS/utils';
import { fetchReports, getReportsStatuses, fetchReportsSummary, getReportStatusById } from 'HELPERS/reports';
import { history } from 'STORE/configureStore';
import queryString from 'query-string';
import { message } from 'antd';

const delay = ms => new Promise(res => setTimeout(res, ms));

const errorPage = '/sorry';
const errorApiMessage = 'Something went wrong when contacting Newsroom API, please let Engineering know';

export function* watchFetchReport(action) {
  try {
    const fetchParams = { ...action.params };

    if (Object.prototype.hasOwnProperty.call(fetchParams, 'campaign_status_id') && fetchParams.campaign_status_id === 'all') {
      delete fetchParams.campaign_status_id;
    }

    if (Object.prototype.hasOwnProperty.call(fetchParams, 'campaign_status_id') && fetchParams.campaign_status_id === 'notSent') {
      delete fetchParams.campaign_status_id;
      const allStatuses = getReportsStatuses();
      const notSentIds = allStatuses.filter(status => (status.name !== 'sent' && status.name !== 'problem' && status.name !== 'save')).map(status => status.id);
      fetchParams.campaign_status_ids = notSentIds;
    }

    const response = yield call(fetchReports, fetchParams);

    yield put({ type: REPORTS.FETCH.COMPLETE });

    if (response.status !== 200) {
      message.error(errorApiMessage);
      // eslint-disable-next-line no-console
      console.error('API Error:', response.status, response.statusText);
      return yield put({ type: REPORTS.FETCH.FAILURE });
    }

    yield put({ type: REPORTS.SUMMARY.REQUEST, params: fetchParams });

    const json = yield call([response, 'json']);

    yield put({
      type: REPORTS.FETCH.SUCCESS,
      payload: { ...json, params: action.params },
    });

    const pureParams = removeEmptyKeys(action.params);
    yield fork(setReportsUrlParams, pureParams);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Saga Error:', error);
    yield put({ type: REPORTS.FETCH.FAILURE });
    return yield history.push({ pathname: errorPage });
  }
}

function* setReportsUrlParams(updateParams) {
  const state = yield select(getStoreState);
  const { location } = state.router;
  const newSearch = queryString.stringify(updateParams);
  yield history.replace({ pathname: location.pathname, search: newSearch });
}

export function* clearFilters(action) {
  const state = yield select(getStoreState);
  const { location } = state.router;
  const searchParsed = queryString.parse(location.search);
  action.filters.forEach((filter) => {
    delete searchParsed[filter];
  });
  const newSearch = queryString.stringify(searchParsed);
  yield history.push({ pathname: location.pathname, search: newSearch });
  return yield put({
    type: REPORTS.REFETCH.REQUEST,
    params: searchParsed,
  });
}

export function* watchSummaryRequests(action) {
  const fetchParams = { ...action.params };
  // Do not filter by status ID.
  delete fetchParams.campaign_status_id;
  return yield fork(getSummary, fetchParams);
}

export function* getSummary(fetchParams) {
  const response = yield call(fetchReportsSummary, fetchParams);
  if (response.status !== 200) {
    message.error(errorApiMessage);
    return yield put({ type: REPORTS.SUMMARY.FAILURE });
  }

  const json = yield call([response, 'json']);
  const statuses = getReportsStatuses();
  const resetStatuses = statuses.reduce((obj, item) => {
    // eslint-disable-next-line
    obj[item.name] = 0;
    return obj;
  }, {});

  let reportsDataSummary = {};
  const responseStatuses = json.reduce((h, a) => Object.assign(h, {
    [a.campaign_status_id]: a,
  }), {});

  const updateStatuses = {};
  Object.keys(responseStatuses).forEach((statusId) => {
    const result = responseStatuses[statusId];
    const status = getReportStatusById(parseInt(statusId, 0));
    updateStatuses[status.name] = result.count;
    reportsDataSummary = {
      statuses: {
        ...resetStatuses,
        ...updateStatuses,
      },
    };
  });

  yield put({
    type: REPORTS.SUMMARY.SUCCESS,
    payload: reportsDataSummary,
  });

  yield delay(5000);
  yield put({ type: REPORTS.SUMMARY.REQUEST, params: fetchParams });
}

export default function* rootSagas() {
  yield takeEvery(REPORTS.FETCH.REQUEST, watchFetchReport);
  yield takeEvery(REPORTS.REFETCH.REQUEST, watchFetchReport);
  yield takeEvery(REPORTS.FILTERS.CLEAR, clearFilters);
  yield takeLatest(REPORTS.SUMMARY.REQUEST, watchSummaryRequests);
}



// WEBPACK FOOTER //
// ./src/store/sagas/reports.sagas.js